import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import MoreMenu from '@components/MoreMenu';
import { CHIP_HEIGHT } from '@components/ResponseItem/styles';

export const ActionsMenu = styled(MoreMenu)({
    '& svg': {
        fontSize: 20,
    },
    '@media (min-width: 1025px)': {
        width: CHIP_HEIGHT,
        height: CHIP_HEIGHT,
        padding: 0,
    },
});

export const Container = styled('section')({
    height: 'calc(var(--100vh) - 96px - var(--page-title-height))',
    backgroundColor: '#F2F2F2',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    overflowY: 'auto',
    borderRadius: 8,
    '@media (max-width: 1024px)': {
        height: 'calc(var(--100vh) - 172px)',
        margin: '0 -16px',
        borderRadius: 0,
    },
});

// INFO: 1 - positive, 0 - neutral, 2 - negative
export const SENTIMENT_COLOR_MAP = {
    1: { backgroundColor: 'rgba(11, 141, 0, 0.1)', color: 'var(--success-main)' },
    0: { backgroundColor: 'rgba(255, 135, 0, 0.15)', color: '#FF8700' },
    2: { backgroundColor: 'rgba(176, 0, 32, 0.1)', color: 'var(--error-main)' },
};

export const ThemeChip = styled(Typography)({
    padding: '2px 6px',
    color: 'var(--primary-main)',
    backgroundColor: 'rgba(31, 76, 92, 0.1)',
    borderRadius: 18,
    height: 'fit-content',
});

export const AspectHighlight = styled('span', {
    shouldForwardProp: prop => prop !== 'sentiment',
})(({ sentiment }) => ({
    backgroundColor: SENTIMENT_COLOR_MAP[sentiment]?.backgroundColor,
    color: SENTIMENT_COLOR_MAP[sentiment]?.color,
    borderRadius: 3,
    padding: '0 2px',
}));

export const KeywordsContainer = styled('div')({
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
    width: 'calc(100% - 250px)',
    '@media (max-width: 700px)': {
        width: '100%',
    },
});

export const FooterWrapper = styled('div')({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 700px)': {
        flexWrap: 'wrap',
        gap: '8px',
    },
});
